import $ from 'jquery';
import 'slick-carousel';

function instagramSlider() {
    var $slider 	= $('.instagram-feed-slider');

	$slider.slick({
		arrows: true,
		autoplay: false,
		autoplaySpeed: 8000,
		infinite: true,
        dots: false,
		rows: 0,
		slidesToShow: 4,
        prevArrow: '<button type="button" class="instagram-feed-slider--arrow-prev"></button>',
		nextArrow: '<button type="button" class="instagram-feed-slider--arrow-next"></button>',
		variableWidth: true,
		responsive: [
			{
			  breakpoint: 1500,
			  settings: {
				slidesToShow: 2,
				prevArrow: '<button type="button" class="instagram-feed-slider--arrow-prev"></button>',
				nextArrow: '<button type="button" class="instagram-feed-slider--arrow-next"></button>',
			  }
			},
			{
			  breakpoint: 1000,
			  settings: {
				slidesToShow: 1,
				prevArrow: '<button type="button" class="instagram-feed-slider--arrow-prev"></button>',
				nextArrow: '<button type="button" class="instagram-feed-slider--arrow-next"></button>',
			  }
			}
		]
	});
}

export { instagramSlider };